import { forwardRef, type ReactNode } from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import clsx from "clsx";
import defaultStyles from "./HotelShopSection.module.scss";

export interface HotelShopSectionComponentProps extends PlatformComponentProps {
  title?: ReactNode;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelShopSection;

export const HotelShopSection = forwardRef<
  HTMLElement,
  HotelShopSectionComponentProps
>(({ className, children, title }, ref) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <section ref={ref} className={clsx(block, className)}>
      {title != null ? <h2 className={cn("title")}>{title}</h2> : null}
      {children}
    </section>
  );
});

HotelShopSection.displayName = "HotelShopSection";
